import { Link } from "react-router-dom";
import { trackNavigation } from "../../utils/analytics";
import "./header.css";

export default function Header() {
  return (
    <header id="header">
      <nav className="main-nav" aria-label="Navigation principale">
        <div className="logo">Grand Hôtel</div>
        <span className="header-separator"></span>
        <ul>
          <li>
            <Link to="/" onClick={() => trackNavigation("/", "Accueil")}>
              Accueil
            </Link>
          </li>
          <li>
            <Link
              to="/appartement-407-4-etoiles-chatel-guyon"
              onClick={() =>
                trackNavigation(
                  "/appartement-407-4-etoiles-chatel-guyon",
                  "Appartement 407",
                )
              }
            >
              Appartement 407
            </Link>
          </li>
          <li>
            <Link
              to="/studio-516-2-etoiles-chatel-guyon"
              onClick={() =>
                trackNavigation(
                  "/studio-516-2-etoiles-chatel-guyon",
                  "Studio 516",
                )
              }
            >
              Studio 516
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              onClick={() => trackNavigation("/contact", "Contact")}
            >
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}
